"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha3 = void 0;
var ethereumjs_util_1 = require("ethereumjs-util");
var SHA3_NULL_S = '0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';
var isHexStrict = function (hex) {
    return /^(-)?0x[0-9a-f]*$/i.test(hex);
};
var sha3 = function (value) {
    var bufferValue;
    if (isHexStrict(value) && /^0x/i.test(value.toString())) {
        bufferValue = (0, ethereumjs_util_1.toBuffer)(value);
    }
    else {
        // Assume value is an arbitrary string
        bufferValue = Buffer.from(value, 'utf-8');
    }
    var returnValue = (0, ethereumjs_util_1.bufferToHex)((0, ethereumjs_util_1.keccak256)(bufferValue));
    if (returnValue === SHA3_NULL_S) {
        return null;
    }
    return returnValue;
};
exports.sha3 = sha3;
//# sourceMappingURL=sha3.js.map